import React from 'react';
import InterveningInfo from './items/InterveningInfo';
//Función principal
const AudienceIntervenings = props => {
    //Tomo los props
    const { audience } = props;
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">INTERVINIENTES</h6>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            {
                                audience.intervinientesList.map((intervening, index) => (
                                    <InterveningInfo
                                        key={`aiii${intervening.id}`}
                                        intervening={intervening}
                                        index={index}
                                    />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceIntervenings;